import { Product } from 'types';
import { Styled } from './';

const OneTimePurchasePrice = ({
  product,
  couponProduct,
  hasMultipleOffers,
}: {
  product: Product;
  couponProduct: any;
  hasMultipleOffers: boolean;
}) => {
  return (
    <Styled.PriceContainer>
      {' '}
      {!hasMultipleOffers && couponProduct && (
        <Styled.Price>{couponProduct.discountPrice}</Styled.Price>
      )}
      <Styled.Price
        $shouldStrikeOff={!hasMultipleOffers && Boolean(couponProduct)}
      >
        {product.displayPrice}
      </Styled.Price>
    </Styled.PriceContainer>
  );
};

export default OneTimePurchasePrice;
